export default __webpack_public_path__ + "assets/bdf1517c7ab30050a7255b0b08030289.svg";